export const FORGET_USER = "FORGET_USER";
export const SEND_OTP = "SEND_OTP";
export const CONFIRM_PASSWORD = "CONFIRM_PASSWORD";
export const FORGET_USER_SUCCESSFUL = "FORGET_USER_SUCCESSFUL";

export const FORGET_PASSWORD_API_FAILED = "FORGET_PASSWORD_API_FAILED";
